import {React, styled} from 'common'
import {Page, PageContent} from 'components/Page'
import AlreadyRegisteredRow from 'components/Welcome/AlreadyRegisteredRow'
import RegisterForm from 'components/Welcome/RegisterForm'
import ContinueToLogin from 'components/Welcome/ContinueToLogin'
import useRegister from 'logic/Welcome/useRegister'
import LoadingDots from 'components/Display/LoadingDots'
import {
    FormActionButton,
    FormCard,
    FormErrorMessage,
    FormWrapper,
} from 'components/Control/Form'
import {Colors} from 'appearance'

const Register = () => {
    const {
        submit,
        formControl,
        formErrors,
        errorMessage,
        successMessage,
        isLoading,
        translate,
        choreographersNames,
        isRegisterInMarkid,
    } = useRegister()

    if (successMessage) {
        return <ContinueToLogin message={successMessage} />
    }

    return (
        <Page noHeader noDrawer>
            <Container centered>
                <FormCard style={{width: 400}}>
                    <FormWrapper onSubmit={submit}>
                        <RegisterForm
                            control={formControl}
                            errors={formErrors}
                            choreographersNames={choreographersNames}
                            isRegisterInMarkid={isRegisterInMarkid}
                        />
                        <RegisterButton
                            onClick={submit}
                            variant="contained"
                            type="submit">
                            {translate('register')}
                        </RegisterButton>
                        <FormErrorMessage errorMessage={errorMessage} />
                        <AlreadyRegisteredRow />
                    </FormWrapper>
                </FormCard>
                <LoadingDots isLoading={isLoading} />
            </Container>
        </Page>
    )
}

export default Register

const Container = styled(PageContent)`
    width: 100%;
    display: flex;
    flex: 1;
    background-color: ${Colors.WHITE};
    // transition: background-color 1s ease-in;
    // &: hover {
    //     background-color: ${Colors.BLUE};
    // }
`
const RegisterButton = styled(FormActionButton)``
